module.exports = __webpack_public_path__ + "media/images/loginpage-background-ce15bcfcfcfb0028d5b6090a314a5d87026d8c2f585a52400fa5854a2f8eb6e2.jpg";